// extracted by mini-css-extract-plugin
export default {"list":"XPBOXS","button":"UDBsK5","title":"K6e1Nw"};